module.exports = __webpack_public_path__ + "static/media/cat_onweer.f0176b48.png";